import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { CalendarView } from '../CalendarView/CalendarView';
import { useCalendarState } from '../CalendarView/hooks/useCalendarState';
import '../CalendarView/Calendar.css';
export const Calendar = React.forwardRef(function Calendar(props, ref) {
    const state = useCalendarState(props);
    return _jsx(CalendarView, Object.assign({ ref: ref }, props, { state: state }));
});
